import { HttpClient } from "@angular/common/http"
import { Injectable } from "@angular/core"

import { Media } from "../models/resource/media"
import { AgreementModalComponent } from "../resource/shared-components/agreement-modal/agreement-modal.component"
import { ModalService } from "../shared-components/modal/modal.service"
import Utils from "../utils/utils"
import { LMModalService } from "./lm-modal.service"
import { UserService } from "./user.service"
import { NotificationsService } from "angular2-notifications"

@Injectable()
export class ResourceDetailsService {
    constructor(
        private http: HttpClient,
        private modalService: ModalService,
        private lmModalService: LMModalService,
        private userService: UserService,
        private notificationService: NotificationsService
    ) {}

    /**
     * Shows a download agreement modal before downloading the zip file.
     */
    public showDownloadAgreement(media: Media) {
        if (!this.userService.isLoggedIn()) {
            this.lmModalService.openLoginModal()
        } else if (media) {
            this.modalService.open(AgreementModalComponent, {
                data: { selectedMedia: media },
            })
        } else {
            this.notificationService.error(
                "Something went wrong",
                "Please try again later",
                Utils.alertConfiguration
            )
        }
    }
}
